import { invalidateMenuCache } from '@fff-web/fff-global-nav';
import { FFFStorage } from '@fff-web/fff-utilities';
import { syncDelay } from './index';

const invalidateCaches = () => {
  // TODO: move this as a stand alone method in fff-utilities
  const userInfoKey = 'user-info-app';
  const invalidateUserCache = () => FFFStorage.removeFromStorage({ key: userInfoKey });

  invalidateUserCache();
  syncDelay(1000);
  invalidateMenuCache();
  syncDelay(4000);
};

export default invalidateCaches;
